import { translation } from "../../../helper/translation"

export const ContentAboutMePageIntroAboutMe = () => {

    

    return(
        <div className="contest-details">
            <div className="container">
            <div className="row">
                <div className="col-lg-12">
                    <div className="top-content">
                        <div className="row">
                        <div className="col-lg-4">
                            <span className="open">{translation("about-me")}</span>
                            <span className="open">{translation("who-am-i")}</span>
                            {/* <span className="wish-list"><i className="fa fa-heart"></i> Add To Your Favorites</span> */}
                        </div>
                        <div className="col-lg-8">
                            {/* <ul>
                                <li><i className="fa fa-medal"></i> <span>Award:</span> $2,400</li>
                                <li><span>Time left:</span> 7 Days</li>
                                <li><span>Participants:</span> 118</li>
                                <li><span>Submittions:</span> 280</li>
                            </ul> */}
                        </div>
                        </div>
                    </div>
                </div>
                <div className="col-lg-12">
                    <div className="main-content">
                        <h4>{translation("who-am-i")}</h4>
                        <h6>{translation("about-me-heading")}</h6>
                        <span>{translation("about-me-text")}</span>
                    </div>
                </div>
            </div>
            </div>
        </div>
    )
}